import { IonContent, IonPage, IonSpinner, useIonViewDidEnter } from '@ionic/react'
import React from 'react'

const Community = () => {

    useIonViewDidEnter(() => {
        const a = document.createElement('a')
        a.href = 'https://chat.whatsapp.com/KPoI2fUfJw2LY6zkNjmV0j'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    })
    return (
        <IonPage>
            <IonContent>
                <div className="ion-padding ion-text-center">
                    <IonSpinner></IonSpinner>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default Community